import { ThemeTypeObj } from '@/config/theme'

/**
 * 获取企业的默认主题
 * 支持通过环境变量 REACT_APP_ENTERPRISE 配置
 */
export const getEnterpriseDefaultTheme = (): string => {
  const enterprise = process.env.REACT_APP_ENTERPRISE || 'luban'
  
  // 根据不同的企业设置不同的默认主题
  const defaultThemes: Record<string, string> = {
    luban: ThemeTypeObj.light,      // 默认亮色主题
    shenhou: ThemeTypeObj.business, // 申厚润企业默认深色主题
    // 可以在这里添加更多企业的配置
  }
  
  return defaultThemes[enterprise] || ThemeTypeObj.light
}

/**
 * 根据企业标识设置 CSS 变量
 * 支持通过环境变量 REACT_APP_ENTERPRISE 配置
 */
export const setEnterpriseTheme = () => {
  const enterprise = process.env.REACT_APP_ENTERPRISE || 'luban'
  
  // 根据不同的企业设置不同的头部背景色
  // 格式: { enterprise: { light: '#ffffff', business: '#288dff' } }
  const headerBgColors: Record<string, { light?: string; business?: string }> = {
    luban: {
      // 默认使用 CSS 中定义的值，不覆盖
    },
    shenhou: {
      light: '#ffffff',    // 申厚润企业亮色主题，可以根据需要修改
      business: '#1a70d2', // 申厚润企业商务主题，可以根据需要修改
    },
    // 可以在这里添加更多企业的配置
  }
  
  const enterpriseConfig = headerBgColors[enterprise] || headerBgColors.luban
  
  // 设置 CSS 变量
  if (typeof document !== 'undefined') {
    const root = document.documentElement
    const currentTheme = root.getAttribute('data-theme') || 'light'
    
    // 如果企业配置中指定了当前主题的颜色，则使用它
    const themeColor = enterpriseConfig[currentTheme as 'light' | 'business']
    if (themeColor) {
      root.style.setProperty('--bg-header', themeColor)
    } else {
      // 如果没有配置，则移除内联样式，使用 CSS 中定义的值
      root.style.removeProperty('--bg-header')
    }
  }
}

